
import { defineComponent } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// module components
import SurveysForm from '@/modules/SurveysModule/components/SurveysForm/index.vue'

export default defineComponent({
    components: {
        'page-title': PageTitle,
        'the-button': TheButton,
        'surveys-form': SurveysForm,
    },
})
